import { useEffect, useState } from "react";
import { fetchData } from "../../APIs/useMyAPI";
import { Row, Col } from "../../Grid-system";
import { Title } from "../../components";
import Loading from "../../Tools/Loading";

const UserAnalytics = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");

  const [filters, setFilters] = useState({
    startDate: getDefaultStart(),
    endDate: getDefaultEnd(),
  });

  useEffect(() => {
    fetchAnalyticsData();
  }, [filters]);

  const fetchAnalyticsData = async () => {
    setIsLoading(true);
    await fetchData(
      `admin/user-analytics`,
      {
        start_date: filters.startDate,
        end_date: filters.endDate,
      },
      "POST"
    )
      .then((res) => {
        setData(res.data.data || res.data || []);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  function getDefaultStart() {
    const d = new Date();
    d.setDate(d.getDate() - 7);
    return formatDateTime(d);
  }

  function getDefaultEnd() {
    const d = new Date();
    return formatDateTime(d);
  }

  function formatDateTime(date) {
    const y = date.getFullYear();
    const m = `0${date.getMonth() + 1}`.slice(-2);
    const d = `0${date.getDate()}`.slice(-2);
    const h = `0${date.getHours()}`.slice(-2);
    const i = `0${date.getMinutes()}`.slice(-2);
    return `${y}-${m}-${d}T${h}:${i}`;
  }

  const totalSum = data.reduce((sum, item) => sum + item.total, 0);
  const netSum = data.reduce((sum, item) => sum + (item.net_total || 0), 0);

  // 🔍 Filter by user_name, email, or phone_number
  const filteredData = data.filter((item) => {
    const searchLower = search.toLowerCase();
    return (
      item.user_name?.toLowerCase().includes(searchLower) ||
      item.email?.toLowerCase().includes(searchLower) ||
      item.phone_number?.toLowerCase().includes(searchLower)
    );
  });

  return (
    <div>
      <Row justify={"between"}>
        <Col md={4}>
          <Title title="User Analytics (Total per User)" />
        </Col>
      </Row>

      <Row className="mt-4 mb-6 items-center">
        <Col md={3}>
          <label className="block text-gray-600 mb-1">Start Date & Time</label>
          <input
            type="datetime-local"
            value={filters.startDate}
            onChange={(e) =>
              setFilters((f) => ({ ...f, startDate: e.target.value }))
            }
            className="w-full py-2 border-2 border-Pink rounded-xl text-center"
          />
        </Col>

        <Col md={3}>
          <label className="block text-gray-600 mb-1">End Date & Time</label>
          <input
            type="datetime-local"
            value={filters.endDate}
            onChange={(e) =>
              setFilters((f) => ({ ...f, endDate: e.target.value }))
            }
            className="w-full py-2 border-2 border-Pink rounded-xl text-center"
          />
        </Col>

        <Col md={4}>
          <label className="block text-gray-600 mb-1">Search</label>
          <input
            type="text"
            placeholder="Search by name, email, or phone..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full py-2 border-2 border-Pink rounded-xl px-3"
          />
        </Col>
      </Row>

      {isLoading ? (
        <Loading />
      ) : (
        <div className="bg-white rounded-3xl overflow-hidden">
          <table className="min-w-full text-sm text-black">
            <thead className="border-b border-gray-400 text-gray-600 uppercase text-xs">
              <tr>
                <th className="px-3 py-2 text-left">User ID</th>
                <th className="px-3 py-2 text-left">User Name</th>
                <th className="px-3 py-2 text-left">Email</th>
                <th className="px-3 py-2 text-left">Phone</th>
                <th className="px-3 py-2 text-left">Orders</th>
                <th className="px-3 py-2 text-left">Net (USD)</th>
                <th className="px-3 py-2 text-left">Total (USD)</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((item, idx) => (
                <tr
                  key={idx}
                  className="border-b border-gray-200 hover:bg-gray-100"
                >
                  <td className="px-3 py-2">{item.user_id || "-"}</td>
                  <td className="px-3 py-2">{item.user_name}</td>
                  <td className="px-3 py-2">{item.email || "-"}</td>
                  <td className="px-3 py-2">{item.phone_number || "-"}</td>
                  <td className="px-3 py-2">{item.orders_count}</td>
                  <td className="px-3 py-2 text-blue-600 font-semibold">
                    {item.net_total?.toFixed(2) || "0.00"}
                  </td>
                  <td className="px-3 py-2 text-Pink font-semibold">
                    {item.total.toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {filteredData.length === 0 && (
            <div className="text-center text-gray-500 py-6">
              No data found for selected range or search.
            </div>
          )}

          {filteredData.length > 0 && (
            <div className="mt-4 text-right text-lg font-semibold pr-6">
              <div className="text-blue-600">
                Total Net: {netSum.toFixed(2)}
              </div>
              <div className="text-Pink">
                Grand Total: {totalSum.toFixed(2)}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default UserAnalytics;
